(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6a5d"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6a5d"] = parcelRequire;
}
parcelRequire.register("bYaKH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8b6da37a9e80d2d0$export$6503ec6e8aabbaf; }, function (v) { return $8b6da37a9e80d2d0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $8b6da37a9e80d2d0$export$f7ad0328861e2f03; }, function (v) { return $8b6da37a9e80d2d0$export$f7ad0328861e2f03 = v; });
var $8b6da37a9e80d2d0$export$6503ec6e8aabbaf;
var $8b6da37a9e80d2d0$export$f7ad0328861e2f03;
"use strict";
var $8b6da37a9e80d2d0$var$mapping = {};
function $8b6da37a9e80d2d0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$8b6da37a9e80d2d0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $8b6da37a9e80d2d0$var$resolve(id) {
    var resolved = $8b6da37a9e80d2d0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$8b6da37a9e80d2d0$export$6503ec6e8aabbaf = $8b6da37a9e80d2d0$var$register;
$8b6da37a9e80d2d0$export$f7ad0328861e2f03 = $8b6da37a9e80d2d0$var$resolve;

});

var $c42e647078ba51da$exports = {};

(parcelRequire("bYaKH")).register(JSON.parse('{"7P4AG":"index.21eca44d.js","gfbBC":"baboon.23379898.png"}'));

})();
//# sourceMappingURL=index.01dc9af5.js.map
